import React from 'react';
import './QuestionCard.css';

interface QuestionCardProps {
  text: string;
  swipeDX: number;
  swipeDY: number;
  agreeLabel: string;
  disagreeLabel: string;
  onTouchStart: (event: React.TouchEvent) => void;
  onTouchMove: (event: React.TouchEvent) => void;
  onTouchEnd: () => void;
}

const QuestionCard: React.FC<QuestionCardProps> = ({
  text,
  swipeDX,
  swipeDY,
  agreeLabel,
  disagreeLabel,
  onTouchStart,
  onTouchMove,
  onTouchEnd,
}) => {
  const absX = Math.abs(swipeDX);
  const absY = Math.abs(swipeDY);
  let revealColor: string | undefined;
  let revealOpacity = 0;
  if (absX > absY && absX > 10) {
    revealColor = swipeDX > 0 ? '#32CD32' : '#ff6ea8';
    revealOpacity = Math.min(0.85, absX / 160);
  }

  const showLeftBadge = swipeDX < -40;
  const showRightBadge = swipeDX > 40;

  return (
    <div className="card-stage">
      <div className="swipe-reveal" style={{ background: revealColor, opacity: revealOpacity }} />
      <div className="corner-label agree" style={{ opacity: Math.max(0, Math.min(1, swipeDX / 100)) }}>{agreeLabel}</div>
      <div className="corner-label disagree" style={{ opacity: Math.max(0, Math.min(1, (-swipeDX) / 100)) }}>{disagreeLabel}</div>
      <div
        className={`tutorial-card`}
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
        style={{
          transform: `translate(${swipeDX * 0.4}px, ${swipeDY * 0.2}px) rotate(${swipeDX * 0.05}deg)`,
          transition: swipeDX === 0 && swipeDY === 0 ? 'transform 150ms ease-out' : 'none',
          boxShadow: revealColor ? `0 0 0 2px ${revealColor}55, 0 12px 24px rgba(0,0,0,0.35)` : undefined,
        }}
      >
        <div className="tutorial-card-content">
          <p className="segment-text" style={{ minHeight: 120 }}>
            {text}
          </p>
        </div>
        {showLeftBadge && <div className="tutorial-badge left">&#10005;</div>}
        {showRightBadge && <div className="tutorial-badge right">&#10003;</div>}
      </div>
    </div>
  );
};

export default QuestionCard;
